import Aura from '@primeuix/themes/aura'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import Tooltip from 'primevue/tooltip'
import { createApp } from 'vue'
import App from './App.vue'
import { i18n } from './i18n'
import { router } from './router'
import { useUiStore } from './stores/ui'
import './styles/app.css'

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      /*
       * 다크 모드를 우리 `data-theme` 속성에 묶는다. PrimeVue 기본값은
       * `.p-dark` 클래스라서, 그대로 두면 테마 토글이 우리 컴포넌트만 바꾸고
       * PrimeVue 컴포넌트는 밝은 채로 남는다.
       */
      darkModeSelector: '[data-theme="dark"]',
      cssLayer: false,
    },
  },
  ripple: false,
})
app.directive('tooltip', Tooltip)
app.use(router)

// 저장된 테마·언어를 첫 프레임 전에 반영한다.
const ui = useUiStore()
i18n.global.locale.value = ui.locale

app.mount('#app')
